module.exports = __webpack_public_path__ + "assets/img/3.6b224dc2.png";